import { render, staticRenderFns } from "./modalAddTenantSetup.vue?vue&type=template&id=34fdf68e&"
import script from "./modalAddTenantSetup.vue?vue&type=script&lang=js&"
export * from "./modalAddTenantSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports